import React, { FC, useCallback, useMemo } from 'react';
import PaginatedReduxTableWithHeader from '../common/PaginatedReduxTableWithHeader';
import { EmptyState } from '../empty_state/EmptyState';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import WorkOrderRowDisplay from '../work_order_row_display/WorkOrderRowDisplay';
import { REQUESTED_PARTS_CRUD_ACTION_CREATORS } from '../../actions/requested_parts_actions';
import { requestedPartsRestCrudThunksForSupplier } from '../../thunks/requested_parts_thunks';
import { getWRPQuantityAndStatusColumns } from '../supplier_work_orders_detail_charges_page/RequestedPartsSectionInWorkOrder';

const ReqestedPartsWorkOrdersList: FC<any> = ({
	backText,
	preAppliedFilters,
	updateFilters,
	clearAndUpdateFilters,
	requestedParts,
	history,
	location,
	targetCollectionName = 'partsWorkOrderList',
}): React.ReactElement => {
	const updatedColumns = useMemo(
		() => [
			{
				title: 'Work Order',
				dataIndex: 'workOrder',
				render: (_) => <WorkOrderRowDisplay workOrder={_} simpler />,
			},
			...getWRPQuantityAndStatusColumns(),
		],
		[]
	);

	const onRow = useCallback(
		(record) => ({
			onClick: () =>
				history.push(
					getLinkWIthBackLinkParams(
						location,
						backText,
						`/supplier/workOrders/detail/${record.workOrderId}/charges`
					)
				),
		}),
		[backText, history, location]
	);

	return (
		<PaginatedReduxTableWithHeader
			targetCollectionName={targetCollectionName}
			updateFilters={updateFilters}
			stateSlice={requestedParts}
			clearAndUpdateFilters={clearAndUpdateFilters}
			filterConfig={[]}
			entityCollectionName="requested_parts"
			tableColumns={updatedColumns}
			fetchData={requestedPartsRestCrudThunksForSupplier.read}
			rightActions={null}
			showHeader
			hideFilters
			onTableRow={onRow}
			preAppliedFilters={preAppliedFilters}
			emptyState={
				<EmptyState
					graphic={
						<img
							alt="No Data"
							style={{ marginBottom: 8 }}
							src="https://s3.amazonaws.com/mock-data-assets/categories/images/box.svg"
						/>
					}
					headline={'No Work Orders found'}
					body={null}
				/>
			}
		/>
	);
};

const mapStateToProps = (state) => ({
	requestedParts: state.requested_parts,
});

const mapDispatchToProps = (dispatch) => ({
	updateFilters: (filters, targetCollection) =>
		dispatch(REQUESTED_PARTS_CRUD_ACTION_CREATORS.updateFilters(filters, targetCollection)),
	clearAndUpdateFilters: (filters, targetCollectionName) =>
		dispatch(
			REQUESTED_PARTS_CRUD_ACTION_CREATORS.clearAndUpdateFilters(filters, targetCollectionName)
		),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(ReqestedPartsWorkOrdersList)
);
